export default __webpack_public_path__ + "static/media/draw-quiz.ea0810d2.svg";